import React from 'react';
import { ItemDto } from '@app/models/dtos/strapi';

function VacancyExpectation({ expect }: { expect: ItemDto }) {
    return (
        <div>
            <p className="P2 !text-black-1">What we expect from you</p>
            <p className="h4-responsive my-6 text-black-1">{expect.title}</p>
            <p className="P1 text-black-2">{expect.description}</p>
        </div>
    );
}

export default VacancyExpectation;
